import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'priceDisplay',
})
export class PriceDisplayPipe implements PipeTransform {
  transform(price: number, currency: string): string {
    const amount = price / 100;
    const formatted = amount.toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const symbol = currency.toLowerCase() === 'eur' ? '€' : currency.toUpperCase();
    return `${formatted}${symbol}`;
  }
}
